export const colorsArticle = [
  {
    ID: 718,
    name: "Aktualności podatkowe",
    bgColor: "#E8E8A1",
    textColor: "#102A41"
  },
  {
    ID: 719,
    name: "Aktualności prawne",
    bgColor: "#F8CA56",
    textColor: "#283A39"
  },
  {
    ID: 713,
    name: "Ceny transferowe",
    bgColor: "#A4358B",
    textColor: "#FFFFFF"
  },
  {
    ID: 715,
    name: "CIT",
    bgColor: "#4EAD33",
    textColor: "#FFFFFF"
  },
  {
    ID: 730,
    name: "Cło i akcyza",
    bgColor: "#BF844D",
    textColor: "#FFFFFF"
  },
  {
    ID: 724,
    name: "E-book",
    bgColor: "#FFFFFF",
    textColor: "#000000"
  },
  {
    ID: 931,
    name: "HR, kadry i płace",
    bgColor: "#F5AF87",
    textColor: "#65191F"
  },
  {
    ID: 927,
    name: "JPK CIT",
    bgColor: "#006366",
    textColor: "#FFFFFF"
  },
  {
    ID: 731,
    name: "Kalendarz podatkowy",
    bgColor: "#E8E8A1",
    textColor: "#102A41"
  },
  {
    ID: 729,
    name: "Kontrole i postępowania",
    bgColor: "#73509C",
    textColor: "#FFFFFF"
  },
  {
    ID: 722,
    name: "KSEF",
    bgColor: "#5ABEB9",
    textColor: "#162C38"
  },
  {
    ID: 723,
    name: "Magazyn - z pasji do podatków",
    bgColor: "#0802AF",
    textColor: "#FFFFFF"
  },
  {
    ID: 728,
    name: "Niskie podatki / CIT estoński",
    bgColor: "#CDDB72",
    textColor: "#FFFFFF"
  },
  {
    ID: 716,
    name: "PIT",
    bgColor: "#BF844D",
    textColor: "#FFFFFF"
  },
  {
    ID: 727,
    name: "Podatek od nieruchomości",
    bgColor: "#EF7A2D",
    textColor: "#FFFFFF"
  },
  {
    ID: 930,
    name: "Podcast",
    bgColor: "#FFFFFF",
    textColor: "#000000"
  },
  {
    ID: 902,
    name: "Pozostałe",
    bgColor: "#BF844D",
    textColor: "#FFFFFF"
  },
  {
    ID: 726,
    name: "Shorts",
    bgColor: "#000000",
    textColor: "#FFFFFF"
  },
  {
    ID: 929,
    name: "Sukcesja i planowanie",
    bgColor: "#F8CA56",
    textColor: "#283A39"
  },
  {
    ID: 725,
    name: "Ulgi podatkowe",
    bgColor: "#E8E8A1",
    textColor: "#102A41"
  },
  {
    ID: 714,
    name: "VAT",
    bgColor: "#9F2232",
    textColor: "#FFFFFF"
  },
  {
    ID: 732,
    name: "ZUS",
    bgColor: "#F5AF87",
    textColor: "#65191F"
  }
];

export const getArticleCategoryBadgeColor = (categoryName: string): string => {
	const category = colorsArticle.find(cat => cat.name === categoryName);
	return category ? category.bgColor : "#BF844D"; // fallback color
};

export const getArticleCategoryTextColor = (categoryName: string): string => {
	const category = colorsArticle.find(cat => cat.name === categoryName);
	return category ? category.textColor : "#FFFFFF"; // fallback color
};

export const getArticleCategoryBadgeStyle = (categoryName: string): { backgroundColor: string; color: string; border: string } => {
	return {
		backgroundColor: getArticleCategoryBadgeColor(categoryName),
		color: getArticleCategoryTextColor(categoryName),
		border: 'none'
	};
};
